// extracted by mini-css-extract-plugin
export default {"root":"Attachment_root__ccyQc","link":"Attachment_link__g+dJ8","labelGroup":"Attachment_labelGroup__Ee3z-","percentage":"Attachment_percentage__tBpKR"};